import { render, staticRenderFns } from "./marketerSettingInManaging.vue?vue&type=template&id=540086f8"
import script from "./marketerSettingInManaging.vue?vue&type=script&lang=js"
export * from "./marketerSettingInManaging.vue?vue&type=script&lang=js"
import style0 from "./marketerSettingInManaging.vue?vue&type=style&index=0&id=540086f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports